import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=5eb35879&scoped=true&"
import script from "./MainFooter.vue?vue&type=script&lang=js&"
export * from "./MainFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb35879",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eb35879')) {
      api.createRecord('5eb35879', component.options)
    } else {
      api.reload('5eb35879', component.options)
    }
    module.hot.accept("./MainFooter.vue?vue&type=template&id=5eb35879&scoped=true&", function () {
      api.rerender('5eb35879', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/MainFooter.vue"
export default component.exports